import React, { useState } from "react";
import { Box, Typography, Grid, CircularProgress, Divider, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import CustomButton from "../../common/CustomButton";
import CustomTextField from "../../common/CustomTextField";
import CustomTextarea from "../../common/CustomTextarea";
import { genericPost } from '../../../services/authServices';
import { CREATE_IMPORT_PAYMENT_VOUCHER } from '../../../services/apiRoutes';
import CustomAutocomplete from "../../common/CustomAutoComplete";
import CustomStyle from "../../common/CustomStyle";
import CustomPrefixSuffixField from "../../common/CustomPrefixSuffixField";
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ClearRounded, SaveRounded, AddRounded, } from "@mui/icons-material";
import { t } from "../../../constants/translationHelper";

const CreatePaymentVoucher = ({ handleClose, baseCurrencySymbol, userId, paymentToList, partyLedger, customerList, companyId, fetchButtonList, commercialInvoiceList, shipmentOrgId, proformaInvoiceList, currencySymbol, baseCurrencyId, currencyId, setMessage, fetchData, currencyList, paymentType, clientCompanyId, commanShipmentId, newShippingId, shipmentId }) => {

    const ValidationSchema = Yup.object().shape({
        date: Yup.string().required('Date is required'),
        paymentVoucherNo: Yup.string().required('Payment Voucher Number is required'),
        amount: Yup.number().required('Amount is required'),
        currencyId: Yup.number().required('Currency is required'),
        paymentTo: Yup.number().required('Payment To is required'),
        baseCurrencyId: Yup.number().required('Base Currency is required'),
        conversionRate: Yup.number().required('Conversion Rate is required'),
        amountInBaseCurrency: Yup.number().required('Amount in Base is required'),
        bankCharges: Yup.number().required('Bank Charges are required'),
        partyLedgerId: Yup.number().when("paymentTo", {
            is: 3,
            then: (schema) => schema.required("Party Ledger is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        clientCompanyId: Yup.number().when("paymentTo", {
            is: (val) => val === 1 || val === 2,
            then: (schema) => schema.required("Supplier Name is required"),
            otherwise: (schema) => schema.notRequired(),
        }),
        // particulars: Yup.array()
        //     .of(
        //         Yup.object().shape({
        //             exportReferenceCiNo: Yup.string().required("CI is required"),
        //             referenceAmount: Yup.number().required("amount is required"),
        //             exportPiNo: Yup.string().required("PI is required"),
        //             paymentTypeId: Yup.string().required("payment Type is required"),
        //             amountInBaseCurrency: Yup.number().required("amount In Base is required"),
        //             conversionRate: Yup.number().required("conversion Rate is required"),
        //         })
        //     )
        //     .required("Particulars are required"),
        particulars: Yup.array().when("paymentTo", {
            is: (val) => val === 1 || val === 2,
            then: (schema) =>
                schema
                    .of(
                        Yup.object().shape({
                            exportReferenceCiNo: Yup.string().required("CI is required"),
                            referenceAmount: Yup.number().required("amount is required"),
                            exportPiNo: Yup.string().required("PI is required"),
                            paymentTypeId: Yup.string().required("payment Type is required"),
                            amountInBaseCurrency: Yup.number().required("amount In Base is required"),
                            conversionRate: Yup.number().required("conversion Rate is required"),
                        })
                    )
                    .min(1, "At least one particular is required"),
            otherwise: (schema) => schema.notRequired(),
        }),


    });

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            // Inject date and bankCharges into each particular
            const updatedParticulars = values.particulars.map(particular => ({
                ...particular,
                date: values.date,
                bankCharges: values.bankCharges,
            }));
            const payload = {
                commanShipmentId: values.commanShipmentId,
                shipmentOrgId: values.shipmentOrgId,
                clientCompanyId: values.clientCompanyId,
                shipmentId: values.shipmentId,
                date: values.date,
                paymentVoucherNo: values.paymentVoucherNo,
                amount: values.amount,
                currencyId: values.currencyId,
                baseCurrencyId: values.baseCurrencyId,
                conversionRate: values.conversionRate,
                amountInBaseCurrency: values.amountInBaseCurrency,
                bankCharges: values.bankCharges,
                note: values.note,
                reference: values.reference,
                // particulars: updatedParticulars,
                paymentTo: values.paymentTo,
                partyLedgerId: values.paymentTo === 3 ? values.partyLedgerId : null,

            };

            // Only include particulars if paymentTo is 1 or 2
            if (values.paymentTo === 1 || values.paymentTo === 2) {
                const updatedParticulars = values.particulars.map((p) => ({
                    ...p,
                    date: values.date,
                    bankCharges: values.bankCharges,
                }));
                payload.particulars = updatedParticulars;
            }


            const response = await genericPost(CREATE_IMPORT_PAYMENT_VOUCHER, payload);

            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "Payment voucher created successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchData();
                    fetchButtonList();
                    handleClose();
                }, 1000);
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    const [formData] = useState({
        commanShipmentId: commanShipmentId,
        clientCompanyId: clientCompanyId,
        shipmentOrgId: shipmentOrgId,
        shipmentId: shipmentId,
        paymentVoucherNo: newShippingId,
        baseCurrencyId: baseCurrencyId,
        currencyId: currencyId,
        amountInBaseCurrency: '',
        date: '',
        amount: '',
        conversionRate: '',
        bankCharges: '',
        note: '',
        reference: '',
        paymentTo: '',
        partyLedgerId: '',

        particulars: [
            {
                shipmentOrgId: shipmentOrgId,
                commanShipmentId: commanShipmentId,
                paymentVoucherNo: newShippingId,
                currencyId: currencyId,
                baseCurrencyId: baseCurrencyId,
                userId: userId,
                companyId: companyId,
                date: "",
                bankCharges: "",
                exportReferenceCiNo: "",
                importReferenceCiNo: "",
                referenceAmount: "",
                importPiNo: "",
                exportPiNo: "",
                paymentTypeId: "1", // 1 for advance payment in case export shipment 
                amountInBaseCurrency: "",
                conversionRate: "",
            },
        ],

    });

    return (
        <Box sx={{ mx: 'auto', mt: 0 }}>
            <Formik
                initialValues={formData}
                validationSchema={ValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, errors, touched, handleChange, setFieldValue, values, resetForm }) => (
                    <Form>
                        <Grid container spacing={1} style={CustomStyle.container}>
                            <Grid item xs={4} md={4}>
                                <Typography sx={{ fontWeight: 600 }} style={CustomStyle.title}>
                                    {t("Create Payment Voucher")}
                                </Typography>
                            </Grid>
                            <Grid item xs={8} md={8} style={CustomStyle.buttonContainer}>
                                <Box style={CustomStyle.buttonBox}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save And New"}
                                        size="small"
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                    <CustomButton
                                        startIcon={<ClearRounded />}
                                        title="Cancel"
                                        size="small"
                                        variant="contained"
                                        onClick={handleClose}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid container spacing={2} sx={{ px: "5%", paddingTop: "5px" }}>
                            {/* @@@@@@@@@@@@@@@ start */}
                            <Grid item xs={12} md={6}>
                                <CustomAutocomplete
                                    options={paymentToList}
                                    fieldLabel="Select payment To"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={paymentToList.find((option) => option.id === values.paymentTo) || null}
                                    onChange={(e, newValue) => {
                                        const selectedPaymentTo = newValue ? newValue.id : "";
                                        resetForm({
                                            values: {
                                                ...formData,
                                                paymentTo: selectedPaymentTo,
                                            },
                                        });
                                    }}
                                    placeholder="Select payment To"
                                    error={touched.paymentTo && !!errors.paymentTo}
                                    helperText={touched.paymentTo && errors.paymentTo}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    placeholder="Enter Payment Voucher No."
                                    name="paymentVoucherNo"
                                    fieldLabel="Payment Voucher Number"
                                    required={true}
                                    value={values.paymentVoucherNo}
                                    onChange={handleChange}
                                    error={touched.paymentVoucherNo && !!errors.paymentVoucherNo}
                                    helperText={touched.paymentVoucherNo && errors.paymentVoucherNo}
                                    sx={CustomStyle.readOnly}
                                    readOnly={true} />
                            </Grid>
                            {/* Show Supplier Name when paymentTo = 1 or 2 */}
                            {(values.paymentTo === 1 || values.paymentTo === 2) && (
                                <Grid item xs={12} md={6}>
                                    <CustomAutocomplete
                                        options={customerList}
                                        fieldLabel="Customer Name"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={customerList.find((option) => option.id === values.clientCompanyId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('clientCompanyId', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Customer Name"
                                        readOnly={true}
                                        sx={CustomStyle.readOnly}
                                        error={touched.clientCompanyId && !!errors.clientCompanyId}
                                        helperText={touched.clientCompanyId && errors.clientCompanyId}
                                    />
                                </Grid>
                            )}
                            {/* Show Party Ledger when paymentTo = 3 */}
                            {values.paymentTo === 3 && (
                                <Grid item xs={12} md={6}>
                                    <CustomAutocomplete
                                        options={partyLedger}
                                        fieldLabel="Select Party Ledger"
                                        required={true}
                                        getOptionLabel={(option) => option.title}
                                        value={partyLedger.find((option) => option.id === values.partyLedgerId) || null}
                                        onChange={(e, newValue) =>
                                            setFieldValue('partyLedgerId', newValue ? newValue.id : '')
                                        }
                                        placeholder="Select Party Ledger"
                                        error={touched.partyLedgerId && !!errors.partyLedgerId}
                                        helperText={touched.partyLedgerId && errors.partyLedgerId}
                                    />
                                </Grid>
                            )}
                            {/* @@@@@@@@@@@@@@@ end */}

                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    placeholder="Enter Date"
                                    type="date"
                                    name="date"
                                    fieldLabel="Date"
                                    required={true}
                                    value={values.date}
                                    onChange={handleChange}
                                    error={touched.date && !!errors.date}
                                    helperText={touched.date && errors.date}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomAutocomplete
                                    options={currencyList}
                                    fieldLabel="Currency"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={currencyList.find((option) => option.id === values.currencyId) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('currencyId', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select Currency"
                                    error={touched.currencyId && !!errors.currencyId}
                                    helperText={touched.currencyId && errors.currencyId}
                                    sx={CustomStyle.readOnly}
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomPrefixSuffixField
                                    prefix={currencySymbol}
                                    placeholder="Amount"
                                    name="amount"
                                    fieldLabel="Amount"
                                    required={true}
                                    type="number"
                                    value={values.amount}
                                    onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue('amountInBaseCurrency', e.target.value * values.conversionRate || 0);
                                    }}
                                    error={touched.amount && !!errors.amount}
                                    helperText={touched.amount && errors.amount}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomAutocomplete
                                    options={currencyList}
                                    fieldLabel="Base Currency"
                                    required={true}
                                    getOptionLabel={(option) => option.title}
                                    value={currencyList.find((option) => option.id === values.baseCurrencyId) || null}
                                    onChange={(e, newValue) =>
                                        setFieldValue('baseCurrencyId', newValue ? newValue.id : '')
                                    }
                                    placeholder="Select Base Currency"
                                    error={touched.baseCurrencyId && !!errors.baseCurrencyId}
                                    helperText={touched.baseCurrencyId && errors.baseCurrencyId}
                                    sx={CustomStyle.readOnly}
                                    readOnly={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <CustomPrefixSuffixField
                                    prefix={baseCurrencySymbol}
                                    tagLine="(In Base)"
                                    placeholder="Conversion Rate"
                                    name="conversionRate"
                                    fieldLabel="Conversion Rate"
                                    required={true}
                                    type="number"
                                    value={values.conversionRate}
                                    onChange={(e) => {
                                        handleChange(e);
                                        setFieldValue('amountInBaseCurrency', values.amount * e.target.value || 0);
                                    }}
                                    error={touched.conversionRate && !!errors.conversionRate}
                                    helperText={touched.conversionRate && errors.conversionRate}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <CustomPrefixSuffixField
                                    prefix={baseCurrencySymbol}
                                    tagLine="(In Base Currency)"
                                    placeholder="Enter Amount"
                                    name="amountInBaseCurrency"
                                    fieldLabel="Amount"
                                    required={true}
                                    type="number"
                                    value={values.amountInBaseCurrency}
                                    onChange={handleChange}
                                    error={touched.amountInBaseCurrency && !!errors.amountInBaseCurrency}
                                    helperText={touched.amountInBaseCurrency && errors.amountInBaseCurrency}
                                    readOnly={true}
                                    sx={CustomStyle.readOnly}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomPrefixSuffixField
                                    prefix={baseCurrencySymbol}
                                    tagLine="(In Base Currency)"
                                    placeholder="Enter Bank Charges"
                                    name="bankCharges"
                                    fieldLabel="Bank Charges"
                                    required={true}
                                    type="number"
                                    value={values.bankCharges}
                                    onChange={handleChange}
                                    error={touched.bankCharges && !!errors.bankCharges}
                                    helperText={touched.bankCharges && errors.bankCharges}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    placeholder="Enter Reference"
                                    name="reference"
                                    fieldLabel="reference"
                                    type="text"
                                    value={values.reference}
                                    onChange={handleChange}
                                />
                            </Grid>

                            {(values.paymentTo === 1 || values.paymentTo === 2) && (

                                <Grid item xs={12}>
                                    <FieldArray
                                        name="particulars"
                                        render={arrayHelpers => (
                                            <>
                                                <Grid item xs={12}>
                                                    <Grid item xs={12} md={6}>
                                                        <Box display="flex" flexDirection="row" alignItems="center">
                                                            <AssignmentLateOutlinedIcon />
                                                            <Typography style={{ fontWeight: 700, color: "#212529", fontSize: "16px", marginLeft: "4px" }}>
                                                                {t("Particulars")}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Box style={{ overflowX: 'auto', overflowY: 'auto' }}>
                                                        <Table style={{ minWidth: '1200px', width: '100%' }}>
                                                            <TableHead>
                                                                <TableRow style={{ height: '40px', backgroundColor: "#e7f0f7" }}>
                                                                    <TableCell style={{ ...styles.tablecell, width: "10px" }}  >{t("No.")}</TableCell>
                                                                    <TableCell style={{ ...styles.tablecell }}  >{t("Proforma Invoice")}</TableCell>
                                                                    <TableCell style={{ ...styles.tablecell }}  >{t("Commercial Invoice")}</TableCell>
                                                                    <TableCell style={{ ...styles.tablecell }}  >{t("Amount")}</TableCell>
                                                                    <TableCell style={{ ...styles.tablecell }}  >{t("Conversion Rate")}</TableCell>
                                                                    <TableCell style={{ ...styles.tablecell }}  >{t("Base Amount")}</TableCell>
                                                                    <TableCell style={{ ...styles.tablecell, width: "10px" }} rowSpan={2}>{t("Action")}</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>

                                                                {values.particulars.map((particular, index) => {
                                                                    return (
                                                                        <TableRow key={index}>
                                                                            <TableCell style={styles.tablecell}>{index + 1}</TableCell>
                                                                            <TableCell style={{ ...styles.tablecell, width: "200px" }}>
                                                                                <CustomAutocomplete
                                                                                    required={true}
                                                                                    options={proformaInvoiceList}
                                                                                    getOptionLabel={(option) => option.title}
                                                                                    value={
                                                                                        proformaInvoiceList.find(
                                                                                            (option) => option.id === values.particulars[index].exportPiNo
                                                                                        ) || null
                                                                                    }
                                                                                    onChange={(e, newValue) => {
                                                                                        setFieldValue(`particulars.${index}.exportPiNo`, newValue ? newValue.id : '');
                                                                                    }}
                                                                                    placeholder="Proforma Invoice"
                                                                                    error={touched.particulars?.[index]?.exportPiNo && !!errors.particulars?.[index]?.exportPiNo}
                                                                                    helperText={touched.particulars?.[index]?.exportPiNo && errors.particulars?.[index]?.exportPiNo}
                                                                                />
                                                                            </TableCell>

                                                                            <TableCell style={{ ...styles.tablecell, width: "200px" }}>
                                                                                <CustomAutocomplete
                                                                                    required={true}
                                                                                    options={commercialInvoiceList}
                                                                                    getOptionLabel={(option) => option.title}
                                                                                    value={
                                                                                        commercialInvoiceList.find(
                                                                                            (option) => option.id === values.particulars[index].exportReferenceCiNo
                                                                                        ) || null
                                                                                    }
                                                                                    onChange={(e, newValue) => {
                                                                                        setFieldValue(`particulars.${index}.exportReferenceCiNo`, newValue ? newValue.id : '');
                                                                                    }}

                                                                                    placeholder="Commercial Invoice"
                                                                                    error={touched.particulars?.[index]?.exportReferenceCiNo && !!errors.particulars?.[index]?.exportReferenceCiNo}
                                                                                    helperText={touched.particulars?.[index]?.exportReferenceCiNo && errors.particulars?.[index]?.exportReferenceCiNo}
                                                                                />
                                                                            </TableCell>

                                                                            <TableCell style={styles.tablecell}>
                                                                                <CustomPrefixSuffixField
                                                                                    prefix={currencySymbol}
                                                                                    required={true}
                                                                                    name={`particulars.${index}.referenceAmount`}
                                                                                    type="number"
                                                                                    value={particular.referenceAmount || ''}
                                                                                    onChange={(e) => {
                                                                                        handleChange(e);
                                                                                        const refAmount = parseFloat(e.target.value) || 0;
                                                                                        const convRate = parseFloat(values.particulars[index].conversionRate) || 0;
                                                                                        setFieldValue(`particulars.${index}.amountInBaseCurrency`, refAmount * convRate);
                                                                                    }}
                                                                                    placeholder="Amount"
                                                                                    error={touched.particulars?.[index]?.referenceAmount && !!errors.particulars?.[index]?.referenceAmount}
                                                                                    helperText={touched.particulars?.[index]?.referenceAmount && errors.particulars?.[index]?.referenceAmount}
                                                                                />

                                                                            </TableCell>
                                                                            <TableCell style={styles.tablecell}>
                                                                                <CustomPrefixSuffixField
                                                                                    prefix={baseCurrencySymbol}
                                                                                    required={true}
                                                                                    name={`particulars.${index}.conversionRate`}
                                                                                    type="number"
                                                                                    value={particular.conversionRate || ''}
                                                                                    onChange={(e) => {
                                                                                        handleChange(e);
                                                                                        const convRate = parseFloat(e.target.value) || 0;
                                                                                        const refAmount = parseFloat(values.particulars[index].referenceAmount) || 0;
                                                                                        setFieldValue(`particulars.${index}.amountInBaseCurrency`, refAmount * convRate);
                                                                                    }}
                                                                                    placeholder="Conversion Rate"
                                                                                    error={touched.particulars?.[index]?.conversionRate && !!errors.particulars?.[index]?.conversionRate}
                                                                                    helperText={touched.particulars?.[index]?.conversionRate && errors.particulars?.[index]?.conversionRate}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell style={styles.tablecell}>
                                                                                <CustomPrefixSuffixField
                                                                                    prefix={baseCurrencySymbol}
                                                                                    required={true}
                                                                                    name={`particulars.${index}.amountInBaseCurrency`}
                                                                                    type="number"
                                                                                    value={particular.amountInBaseCurrency || ''}
                                                                                    onChange={handleChange}
                                                                                    placeholder="Base Amount"
                                                                                    error={touched.particulars?.[index]?.amountInBaseCurrency && !!errors.particulars?.[index]?.amountInBaseCurrency}
                                                                                    helperText={touched.particulars?.[index]?.amountInBaseCurrency && errors.particulars?.[index]?.amountInBaseCurrency}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell style={styles.tablecell}>
                                                                                <DeleteOutlineOutlinedIcon
                                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                                    style={{ fontSize: "20px" }} />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                            </TableBody>

                                                            <TableRow style={{ height: '40px' }}>
                                                                <TableCell style={styles.tablecell} colSpan={8}>
                                                                    <div style={{ margin: "auto", textAlign: "center" }}>
                                                                        <CustomButton
                                                                            sx={Additemstyle}
                                                                            startIcon={<AddRounded />}
                                                                            title="Add Item"
                                                                            variant="contained"
                                                                            size="small"
                                                                            onClick={() => arrayHelpers.push({
                                                                                exportReferenceCiNo: '',
                                                                                referenceAmount: '',
                                                                            })}
                                                                        />
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                            <TableRow style={{ height: '40px' }}>
                                                                <TableCell style={styles.tablecellfooter} colSpan={3}  > {t("Total")}</TableCell>
                                                                <TableCell style={styles.tablecellfooter}>
                                                                    {currencySymbol}&nbsp;
                                                                    {(
                                                                        values.particulars.reduce((total, particular) => {
                                                                            const referenceAmount = parseFloat(particular.referenceAmount) || 0;
                                                                            return total + referenceAmount;
                                                                        }, 0)
                                                                    ).toFixed(2)}
                                                                </TableCell>

                                                                <TableCell style={styles.tablecellfooter} colSpan={3} >
                                                                    {baseCurrencySymbol}&nbsp;
                                                                    {(
                                                                        values.particulars.reduce((total, particular) => {
                                                                            const amountInBaseCurrency = parseFloat(particular.amountInBaseCurrency) || 0;
                                                                            return total + amountInBaseCurrency;
                                                                        }, 0)
                                                                    ).toFixed(2)}
                                                                </TableCell>

                                                            </TableRow>

                                                        </Table>
                                                    </Box>
                                                </Grid>
                                            </>
                                        )}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={12} md={8}>
                                <CustomTextarea
                                    name="note"
                                    fieldLabel="Note"
                                    value={values.note}
                                    onChange={handleChange}
                                    sx={{ height: '80px !important' }}
                                    placeholder="Enter Note"
                                />
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

export default CreatePaymentVoucher;



const styles = {
    table: {
        minWidth: 650,
    },
    textMuted: {
        color: '#6c757d',
    },

    labelCell: {
        width: '180px',
    },
    tableContainer: {
        marginBottom: '16px',
    },
    header: {
        marginBottom: '16px',
    },
    title: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    customTableRow: {
        height: '20px',
    },
    editButton: {
        textAlign: 'right',
    },
    showDetailsSpan: {
        padding: '8px',
        fontWeight: 600,
        fontSize: '16px',
        color: '#212529',
        cursor: 'pointer',
    },
    expandIcon: {
        color: '#212529',
    },
    boxheading: {
        width: 70,  // Width of the box
        height: 70, // Height of the box, making it square
        background: 'radial-gradient(circle, #007BFF 0, rgba(0, 134, 201, .5) 0, #007BFF 100%)', // Radial gradient background
        color: 'white', // Text color
        display: 'flex', // Center content horizontally
        alignItems: 'center', // Center content vertically
        justifyContent: 'center', // Center content horizontally
        borderRadius: 14, // Rounded corners
        boxShadow: 3, // Box shadow for depth
    },
    headingname: {
        paddingTop: '10px',
        fontWeight: '600',
        fontSize: '20px',
        color: '#212529',
    },
    avatarcircle: {
        backgroundColor: '#007BFF',
        width: '30px',
        height: '30px',
        fontSize: '15px',
    },
    cardtittile: {
        padding: '8px',
        paddingLeft: '35px',
        fontWeight: 600,
        fontSize: '16px',
        color: '#212529',
    },
    tablebutton: {
        backgroundColor: '#007bff',
        color: '#ffff',
        textTransform: 'capitalize',
        borderRadius: 4,
        border: '2px solid #007bff',
        height: 30,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tablecell: {
        border: '1px solid #dee2e6',
        color: '#212529',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'center',
        padding: '1px',
        paddingLeft: "10px",
        paddingRight: "10px",
        whiteSpace: "nowrap"
    },
    tablecellfooter: {
        border: '1px solid #dee2e6',
        color: '#212529',
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'right',
        padding: '1px',
        paddingLeft: "10px",
        paddingRight: "10px",
    },

};


const Additemstyle = {
    color: '#212529 !important',
    textTransform: 'capitalize !important',
    borderRadius: '4px !important',
    border: '1px dashed #aecce4 !important',
    height: '30px !important',
    display: 'inline-flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    backgroundColor: '#e7f0f7 !important',
    width: '100% !important',
};
